import React from 'react';
import LandingNavbar from './LandingNavbar';
import Hero from './Hero';
import Features from './Features';
import ContactSection from './ContactSection';
import Footer from './Footer';
import BackgroundDecorations from './BackgroundDecorations';
import styles from './LandingPage.module.scss';

const LandingPage: React.FC = () => {
  return (
    <div className={styles.landingPage}>
      <BackgroundDecorations />
      <div className={styles.content}>
        <LandingNavbar />
        <Hero />
        <Features />
        <ContactSection />
        <Footer />
      </div>
    </div>
  );
};

export default LandingPage;
